export const EMPTY_MESSAGE = {
  LOADING_DATA: 'grid.loading_data',
  NOT_FOUND: 'grid.not_found'
};



// WEBPACK FOOTER //
// /dist/src/app/shared/empty-message.const.ts